import Icon from '$store/components/ui/Icon.tsx'
import { useUser } from 'apps/vtex/hooks/useUser.ts'
import { Signal } from '@preact/signals'
import { useUI } from '$store/sdk/useUI.ts'

interface Props {
	displayMenu?: Signal<boolean>
}

function Login({ displayMenu }: Props) {
	const { user } = useUser()
	// const user = useSignal({
	//     '@id': 'test-id',
	//     'email': 'johndoe@agency.com.br',
	//     'givenName': null,
	//     'familyName': null,
	//     'gender': 'https://schema.org/Male',
	// })

	const isLoggedIn = !!user.value?.email

	const { vtexIdScriptsLoaded } = useUI()

	const handleOpenLogin = async (e: MouseEvent) => {
		e.preventDefault()
		if (displayMenu) displayMenu.value = false
		const execute = () => {
			vtexIdScriptsLoaded.value = true
			// deno-lint-ignore ban-ts-comment
			// @ts-expect-error
			window.vtexid.start({
				userEmail: '',
				locale: 'pt-BR',
				forceReload: true,
			})
		}
		if (!vtexIdScriptsLoaded.value) {
			const { loadVtexIdScripts } = await import(
				'$store/sdk/loadVtexIdScripts.ts'
			)
			loadVtexIdScripts(execute)
		} else {
			execute()
		}
	}

	return (
		<div data-logged={isLoggedIn} class='group relative pl-4'>
			<label tabIndex={0} class='h-[60px] flex items-center'>
				<a class='flex items-center gap-3 group text-neutral-0'>
					{/* Desktop Icon */}
					<Icon
						id='User'
						class='hidden lg:flex flex-shrink-0 text-white header-icon'
						width={18}
						height={18}
					/>
					{/* Mobile Icon */}
					<Icon
						id='NewUser'
						class='flex lg:hidden flex-shrink-0 text-neutral-0'
						strokeWidth={1}
						width={24}
						height={24}
					/>

					<div class='text-white text-xs whitespace-nowrap'>
						<p class='hidden lg:block text-login-text'>LOGIN</p>
						<>
							<div class='block lg:hidden'>
								{!isLoggedIn
									? (
										<a
											class='flex text-sm text-neutral-0 lg:text-white gap-1'
											href={'#'}
											onClick={handleOpenLogin}
										>
											<span class='text-xs underline font-normal text-white'>
												Entrar
											</span>
											<span class='text-xs font-normal text-white'>ou</span>
											<span class='text-xs underline font-normal text-white'>
												Cadastre-se
											</span>
										</a>
									)
									: (
										<div class='flex gap-5 items-center text-sm'>
											<p class='truncate max-w-[100px] text-xs underline font-normal text-white'>
												Olá, {user.value?.email}
											</p>
											<a
												href={`/api/vtexid/pub/logout?scope=dabelleoficial&returnUrl=/`}
												class=' text-xs underline font-normal text-white'
											>
												[sair]
											</a>
										</div>
									)}
							</div>
						</>
					</div>
				</a>
			</label>

			<ul
				tabIndex={0}
				class=' bg-white w-[150px] text-sm text-gray-500 hidden lg:group-hover:block lg:absolute lg:py-3 lg:-top-[14px] shadow-xl lg:right-1/2 lg:translate-x-1/2  lg:box-shadow-dropdown lg:z-[1] lg:rounded-md'
			>
				<p class='text-center text-xs text-gray-500 mb-3 pt-2 truncate w-[100px] mx-auto'>
					{user.value?.email ? `Olá, ${user.value.email}` : 'LOGIN'}
				</p>
				<div>
					{!isLoggedIn && (
						<li class='w-full justify-center hidden lg:flex text-xs text-gray-500 hover:font-medium transition-all'>
							<a
								aria-label='Minha conta'
								class='block px-2 py-1 text-gray-500'
								href={'#'}
								onClick={handleOpenLogin}
							>
								Entrar/Cadastrar
							</a>
						</li>
					)}
					<li class='hover:bg-gray-200 w-full justify-center hidden lg:flex text-xs text-gray-500 hover:font-medium transition-all'>
						<a aria-label='Meus pedidos' class='block px-2 py-1' href='/orders'>
							Meus Pedidos
						</a>
					</li>
					<li class='hover:bg-gray-200 hidden lg:flex w-full lg:justify-center text-gray-500 text-xs hover:font-medium transition-all'>
						<a
							aria-label='Minha conta'
							class='flex items-center lg:justify-center w-full px-2 py-1'
							href={'/conta'}
						>
							Minha Conta
						</a>
					</li>
					{isLoggedIn && (
						<li class='hover:bg-gray-200 hidden lg:flex w-full lg:justify-center text-[#a40202] text-xs hover:font-medium transition-all'>
							<a
								aria-label='Sair'
								class='flex items-center lg:justify-center w-full px-2 py-1'
								href={`/api/vtexid/pub/logout?scope=dabelleoficial&returnUrl=/`}
							>
								Sair (x)
							</a>
						</li>
					)}
				</div>
			</ul>
		</div>
	)
}

export default Login
